import React from "react";
import { SvgProps } from "../types";

const Logo: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  // Use React 18's useId for unique IDs, or fallback
  const gradientId = React.useId ? React.useId() : "linear-gradient-with-text";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" data-name="Layer 2" viewBox="0 0 1064.71 163.52" {...props}>
      <defs>
        <linearGradient id={gradientId} x1={91.72} x2={47.64} y1={52.09} y2={98.04} gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#2463d3" />
          <stop offset={1} stopColor="#6826d1" />
          {/* <stop offset={1} stopColor="#6FC7BA" /> */}
        </linearGradient>
        <style>{".cls-1{fill:#302351}.cls-7{fill:#fefefa}.cls-8{fill:#1e1735}"}</style>
      </defs>
      <g id="Layer_1-2" data-name="Layer 1">
        <text
          style={{
            fill: "#eaeaea",
            fontSize: "128.43px",
          }}
          transform="translate(173 123.32)"
        >
          <tspan
            x={0}
            y={0}
            style={{
              fontFamily: "ScaleVF-Regular,&quot",
              fontVariationSettings: "&quot",
            }}
          >
            {"K"}
          </tspan>
          <tspan
            x={79.37}
            y={0}
            style={{
              fontFamily: "GolosText-Medium,&quot",
              fontWeight: 500,
            }}
          >
            {"aspa Finance"}
          </tspan>
        </text>
        <path
          d="M140.39 56.56c-4.45 1.92-10.03 3.41-13.44 4.14 6.79-24.76-7.77-50.34-32.53-57.14C75.23-1.71 54.24 6.18 43.29 22.8c-3.42 5.19-5.24 11.01-6.93 16.93-4.96 17.41-9.53 35.04-18.11 51.11-4.02 7.53-8.04 15.05-12.05 22.58-1.66 3.11-3.34 6.27-3.99 9.74s-.12 7.32 2.22 9.96c2.76 3.1 7.34 3.83 11.49 3.6 7.01-.39 13.89-2.98 19.41-7.32-.78 3.44-.64 7.08.41 10.44.37 1.19.89 2.38 1.84 3.18 1.1.91 2.6 1.15 4.03 1.26 12.22.93 24.73-5.34 31.3-15.68-2.19 2.83-.87 7.37 2.15 9.3s7.06 1.61 10.28.03 5.77-4.22 8.15-6.89c6.66-7.48 12.59-15.64 17.38-24.44 2.42-4.44 4.54-9.04 6.32-13.77.89-2.37 1.53-4.82 2.38-7.19.6-1.67 1.04-3.88 2.06-5.36 1.04-1.51 6.06-2.04 8.1-2.93 5.99-2.63 11.54-7.51 13.41-13.97.55-1.9 1.23-8.51-2.73-6.81Z"
          style={{
            fill: `url(#${gradientId})`,
          }}
        />
        <path
          d="M100.73 63.04c-8.21 0-14.68-9.09-14.72-20.69-.02-5.41 1.4-10.52 4.01-14.4 2.76-4.11 6.52-6.39 10.59-6.4 8.25 0 14.72 9.09 14.77 20.69.02 5.41-1.4 10.52-4.01 14.4-2.76 4.11-6.52 6.39-10.59 6.4h-.04Z"
          className="cls-7"
        />
        <path
          d="M100.65 23.49c7.02 0 12.74 8.38 12.78 18.75.04 10.38-5.63 18.83-12.66 18.85h-.04c-7.02 0-12.74-8.38-12.78-18.75-.04-10.38 5.63-18.83 12.66-18.85h.04m0-3.9h-.05c-4.67.02-9.11 2.67-12.2 7.27-2.82 4.2-4.36 9.7-4.34 15.5.05 12.69 7.37 22.63 16.67 22.63h.05c4.67-.02 9.11-2.67 12.2-7.27 2.82-4.2 4.36-9.7 4.34-15.5-.05-12.69-7.37-22.63-16.67-22.63Z"
          className="cls-1"
        />
        <ellipse cx={103.5} cy={38.82} className="cls-1" rx={5.92} ry={8.82} transform="rotate(-.23 104.547 40.068)" />
        <ellipse cx={105.92} cy={33.76} className="cls-7" rx={2.88} ry={4.28} transform="rotate(-.23 107.048 35.09)" />
        <path
          d="M44.96 62.52c.84.23 12.69-2.25 21.24-5.94 8.56-3.69 6.24 26.76-27.94 30.36"
          style={{
            fill: `url(#${gradientId})`,
          }}
        />
        <path
          d="M44.96 62.52c5.96-1.47 11.78-3.81 17.46-6.06 1.61-.6 3.01-1.61 4.75-1.85 5.02-.38 5.65 6.19 4.78 9.69-3.27 14.96-19.47 23.21-33.69 22.64 11.42-2.61 23.52-8.39 28.56-19.44 1.13-2.4 1.94-5.32 1.63-7.88-.24-1.09-.42-1.95-1.6-1.5-6.95 2.48-14.5 4.44-21.89 4.4Z"
          className="cls-8"
        />
        <path
          d="m126.95 60.7-4.25 7.72"
          style={{
            fill: `url(#${gradientId})`,
          }}
        />
        <path
          d="M143.88 55.2c-.64-.57-2.05-1.38-4.26-.43-3.11 1.34-6.85 2.49-10.04 3.31 2.37-11.51.5-23.35-5.37-33.65-6.4-11.24-16.8-19.32-29.28-22.74-19.98-5.48-41.88 2.76-53.27 20.05-3.58 5.44-5.44 11.37-7.18 17.47-.45 1.57-.89 3.14-1.34 4.72-4.38 15.52-8.92 31.57-16.62 46.01L4.47 112.52c-1.63 3.05-3.47 6.5-4.19 10.29-.84 4.45.16 8.79 2.68 11.61 3.48 3.91 9.01 4.47 13.05 4.25 5.92-.33 11.77-2.15 16.86-5.22-.04 2.35.29 4.71 1 6.98.4 1.29 1.05 2.93 2.45 4.09 1.53 1.27 3.45 1.57 5.13 1.7.84.06 1.67.1 2.51.1 9.82 0 19.63-4.3 26.43-11.39.68 1.9 1.96 3.57 3.61 4.62 3.33 2.13 8 2.19 12.18.14 3.6-1.76 6.4-4.72 8.75-7.35 7.05-7.91 12.98-16.25 17.64-24.8 2.51-4.61 4.67-9.32 6.43-14.02.49-1.31.91-2.65 1.32-3.94.34-1.09.69-2.21 1.08-3.28.19-.51.36-1.08.53-1.65.37-1.21.75-2.46 1.25-3.21.48-.46 2.75-1.02 3.98-1.32 1.27-.31 2.46-.6 3.34-.99 7.24-3.18 12.66-8.86 14.5-15.21.02-.06 1.66-6.26-1.11-8.71Zm-2.63 7.62c-1.52 5.25-6.13 10.01-12.33 12.73-.58.25-1.66.52-2.71.78-2.64.65-5.13 1.26-6.21 2.84-.89 1.3-1.38 2.92-1.81 4.34-.15.51-.31 1.01-.47 1.47a85.7 85.7 0 0 0-1.13 3.43c-.41 1.3-.79 2.52-1.25 3.74-1.69 4.53-3.78 9.07-6.2 13.52-4.52 8.29-10.28 16.39-17.13 24.08-2.19 2.46-4.58 4.99-7.55 6.44-2.93 1.43-6.21 1.46-8.37.08-1.15-.74-2.05-2.08-2.27-3.53-.54-3.48 2.06-9.99 2.06-9.99s-11.26 21.06-34.15 19.59c-1.06-.07-2.24-.24-2.93-.81-.49-.4-.86-1.1-1.23-2.26a18.18 18.18 0 0 1-.37-9.43l1.22-5.36-4.32 3.4c-5.21 4.09-11.71 6.54-18.32 6.91-3.19.17-7.48-.19-9.93-2.95-1.72-1.93-2.37-5.03-1.76-8.3.6-3.2 2.23-6.24 3.79-9.18l12.05-22.58C27.83 76.97 32.42 60.72 36.86 45c.44-1.57.89-3.14 1.33-4.71 1.65-5.8 3.4-11.42 6.68-16.39C55.39 7.98 75.53.39 93.91 5.44c11.47 3.15 21.04 10.58 26.92 20.92 5.89 10.34 7.4 22.35 4.25 33.83l-.65 2.36-1.73 5.88 5.22-5.95c3.75-.83 9.01-2.31 13.24-4.13.09-.04.16-.06.21-.08.33.79.29 3.14-.12 4.56Z"
          className="cls-8"
        />
      </g>
    </svg>
  );
};
export default Logo;
